import "swagger-ui-react/swagger-ui.css"
import Theme from "@hooks/useTheme";
import React from 'react';
import Router from "./pages/Router";
import "@elcimai/webankdesignsystem/dist/style.css";
import bundle from "@elcimai/webankdesignsystem/dist/img/bundle.svg"
import {IconConfig} from "@elcimai/webankdesignsystem";

IconConfig.bundle = bundle

function App() {
    return (
        <Theme>
                <Router/>
        </Theme>
    )
}

export default App
